import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { abyssColors } from '@/theme/colors';

// Matches the design spec:
//   display: flex; padding: 4px 10px; justify-content: center;
//   align-items: center; gap: 8px; border-radius: 4px;
//   background: var(--Color-Primary-100, #E7EEF6);
const chipSx = {
  display: 'inline-flex',
  padding: '4px 10px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '4px',
  background: abyssColors.primary[100],
  color: abyssColors.primary[600],
  fontSize: '1.2rem',
  fontWeight: 500,
  lineHeight: 'normal',
  whiteSpace: 'nowrap' as const,
  flexShrink: 0,
  marginBottom: '8px'
};

// Horizontal-scroll container, styled to match the reports cell in
// KendoEquipmentTable (`ReportsCell`).
const scrollRowSx = {
  width: '100%',
  overflowX: 'auto' as const,
  overflowY: 'hidden' as const,
  flexWrap: 'nowrap' as const,
  '&::-webkit-scrollbar': {
    height: '0.4rem',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: abyssColors.primary[200],
    borderRadius: '0.4rem',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
};

const Chip: React.FC<{ label: string }> = ({ label }) => (
  <Tooltip title={label} placement="top" arrow>
    <Box sx={chipSx}>
      <Typography component="span" fontSize="1.2rem" fontWeight={500} lineHeight="normal">
        {label}
      </Typography>
    </Box>
  </Tooltip>
);

interface MultiValueChipsCellProps {
  values: string[];
}

export const MultiValueChipsCell: React.FC<MultiValueChipsCellProps> = ({ values }) => {
  return (
    <Stack direction="row" alignItems="center" gap="8px" sx={scrollRowSx}>
      {values.map((value, index) => (
        <Chip key={`${index}-${value}`} label={value} />
      ))}
    </Stack>
  );
};
